import React from 'react';

import { ActionIcon, Flex, TextInput, createStyles, useMantineTheme } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconCheck, IconLink, IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface LinkInputProps {
  onConfirm: (url: string) => void;
  onCancel: () => void;
  initialUrl?: string;
  setIsLinkInputActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const useStyles = createStyles(() => ({
  linkInput: {
    input: {
      border: 'none',
      padding: '0px 4px'
    }
  }
}));

export function SmartEditorLinkInput({ onConfirm, onCancel, initialUrl = '', setIsLinkInputActive }: LinkInputProps) {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const { t } = useTranslation();

  const urlFormat = useForm({
    initialValues: {
      url: initialUrl
    }
  });

  // Set link input active on mount and deactivate on unmount
  React.useEffect(() => {
    setIsLinkInputActive(true);
    return () => {
      setIsLinkInputActive(false);
    };
  }, [setIsLinkInputActive]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') onConfirm(urlFormat.values.url);
    else if (e.key === 'Escape') onCancel();
  };

  return (
    <Flex gap={4} align="center" justify="space-between" px={4}>
      <IconLink size={14} color={theme.colors.gray[5]} />
      <TextInput
        className={classes.linkInput}
        placeholder={t('SMART_EDITOR.BUBBLE_MENU.LINK_PLACEHOLDER')}
        onKeyDown={handleKeyDown}
        autoFocus
        spellCheck={false}
        {...urlFormat.getInputProps('url')}
      />
      <ActionIcon onClick={() => onConfirm(urlFormat.values.url)}>
        <IconCheck />
      </ActionIcon>

      <ActionIcon onClick={onCancel}>
        <IconX />
      </ActionIcon>
    </Flex>
  );
}
